import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  trashButton: {
    position: 'absolute',
    right: 0,
    top: '50%',
    marginTop: '-22px',
  },
  root: {
    display: "flex",
    "& > div": {
      flex: 1,
      position: 'relative',
      marginRight: theme.sizes.spacing.minor,
      "& > label": {
        color: "rgba(0,0,0,.54)",
        fontWeight: "400",
        height: "55px",
        fontSize: "1rem",
        display: "flex",
        alignItems: "center",
        paddingLeft: "14px",
        paddingRight: "14px",
        borderRadius: "5px",
        border: "1px solid #CCC",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        "&.filled": {
          color: "rgba(0,0,0,.87)",
        },
        "&.error": {
          color: theme.palette.error.main,
        },
      },
    },
    "& .MuiButton-root": {
      borderRadius: 0,
      minWidth: "150px",
      height: "55px",
      backgroundColor: theme.palette.primary.light,
    },
  },
}));

export default useStyles;
